<template>
    <b-form-group :label-cols-sm="labelColsSm" :label-cols-lg="labelColsLg" :description="description" :label="label + ':'" :label-for="id" label-class="fs-14 grey-color fw-700 d-flex align-items-baseline" :class="compact ? 'mb-0' : ''">
        <p :id="id" class="fs-14 grey-color my-auto col-form-label">{{ $formatPriceOrMdash(value) }} {{ value ? 'руб.' : '' }}</p>
    </b-form-group>
</template>

<script>
export default {
    name: 'text-row-price',
    props: {
        label: {
            type: String,
            required: true
        },
        value: {
            default: ''
        },
        description: {
            type: String,
            default: ''
        },
        compact: {
            type: Boolean,
            default: false
        },
        labelColsLg: {
            default: 3
        },
        labelColsSm: {
            default: 4
        }
    },
    computed: {
        id() {
            return 'text_row_price_' + this._uid;
        }
    }
};
</script>

<style scoped>
.form-row {
    margin-left: 0;
    margin-right: 0;
}
</style>
